interface BHSelectProps {
  className?: string
  title?: string
  currentValue: number
  onChange: (newValue: number) => void
  options: FormOption<number>[]
  disabled?: boolean
  onFocus?: () => void
  onBlur?: () => void
}

function BHSelect({
  className,
  title = '',
  currentValue,
  onChange,
  options = [],
  disabled,
  onFocus,
  onBlur,
}: BHSelectProps) {

  if (className === undefined) className = '';

  return (
    <div className={`flex flex-col items-left ${className}`}>
      <span className="my-1">{title}</span>
      <select
        className="p-2 border border-bh-black"
        onChange={(e) => {
          onChange(Number(e.target.value))
        }}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        {options.map((option) => (
          <option
            key={`${option.value}`}
            value={option.value}
            selected={option.value === currentValue}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default BHSelect
